import axios from "axios";
import qs from "qs";
const initialState = {
    searchOptions: [
        {
            type: "All",
            params: null,
            routeName: "",
            endpoint: "",
        }
    ],
    searchActive: {
        type: "All"
    },
    searchQuery: ""
}

export const state = { ...initialState};

export const actions = {
    resetSearchOptions(context){
        context.commit("setSearchOptions",
            [{type: "All"}]
        );
        context.commit("setSearchActive",{type: "All"});
    },

    addSearchOption(context,searchOption){
        context.commit("unshiftSearchOptions",searchOption);
    },

    selectedOption(context,searchOption){
        context.commit("setSearchActive",searchOption);
    },

    selectFirstOption(context){
        context.commit("setSearchActive",context.state.searchOptions[0]);
    },

    resetSearchQuery(context) {
        context.commit("setSearchQuery", "");
    }
}

export const mutations = {
    unshiftSearchOptions(state,searchOption){
        state.searchOptions.unshift(searchOption);
    },
    setSearchActive(state,searchOption) {
        state.searchActive = searchOption;
    },
    setSearchOptions(state,searchOptions){
        state.searchOptions = searchOptions;
    },
    setSearchQuery(state,searchQuery) {
        state.searchQuery = searchQuery;
    },
}

const getters = {
    searchQuery(state){
        return state.searchQuery;
    },
    searchOptions(state) {
        return state.searchOptions;
    },
    searchActive(state) {
        return state.searchActive;
    }
}

export default {
    state,
    actions,
    mutations,
    getters
};